import { AutogenLayoutCallListProfileFilter } from "./autogen/AutogenLayoutCallListProfileFilter";
import { CallListProfile } from "./CallListProfile";

export class CallListProfileFilter extends AutogenLayoutCallListProfileFilter {
    override onLoad() {
        const profileLayout = this.layoutProfile as CallListProfile;
        profileLayout.textboxDescr.required = false;
    }
}